export default "__VITE_ASSET__AC5QmQQ6__"